


<script>
try{
  var _baseComponent = require("@/admin/tpl/tabelado.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/admin/tpl/tabelado.vue").default;
}


export default {
  extends: _baseComponent,
  props: ["myself"],
  data() {
    return {};
  }
};
</script>
